import React, { useEffect, useRef } from 'react';
import './Captcha.css'
import { Turnstile } from '@marsidev/react-turnstile';
import { markTurnstileFailed, clearTurnstileFailed } from '../../utils/posthogTurnstile';

const Captcha: React.FC<{ onChange: ((token: string | null) => void), refresh: number }> = ({ onChange, refresh }) => {

  const turnstileRef = useRef<any>(null);

  useEffect(() => {
    //performRefresh(); //children function of interest
    console.log("Reset captcha");
    turnstileRef.current?.reset();
  }, [refresh]);

  return (
    <div className='captcha-container'>
        <Turnstile
          ref={turnstileRef}
          siteKey="0x4AAAAAAB5ChJFN_td-_qfx"
          options={{ theme: 'light' }}
          onSuccess={(token) => {
            clearTurnstileFailed();
            onChange(token);
          }}
          onError={(errorCode) => {
            markTurnstileFailed(errorCode);
            onChange(null);
          }}
          onExpire={() => onChange(null)}
          onUnsupported={() => {
            markTurnstileFailed('unsupported');
            onChange(null);
          }}
        />
    </div>
  )
};

export default Captcha
